import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function orderQtyMoreThanPositionSizeBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Attempt to close{' '}
        {parsedStatusObj.newOrderQty ? parsedStatusObj.newOrderQty : ''}{' '}
        {parsedStatusObj.symbol ? parsedStatusObj.symbol : ''} exceeds position
        size of{' '}
        {parsedStatusObj.restingOrderQty ? parsedStatusObj.restingOrderQty : ''}
        .
      </Body3>
    </td>
  );
}
